import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { AccessDenied } from './AccessDenied';
import './AccessDenied.css';

interface ProtectedRouteProps {
  readonly children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isLoggingOut, isAuthenticated, hasRequiredRole, login } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Don't trigger login if we're in the middle of logging out
    if (!isLoading && !isLoggingOut && !isAuthenticated) {
      const returnUrl = `${location.pathname}${location.search}`;
      login(returnUrl);
    }
  }, [isLoading, isLoggingOut, isAuthenticated, login, location.pathname, location.search]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <span>Loading...</span>
      </div>
    );
  }

  // Show redirecting message for both login and logout redirects
  if (!isAuthenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <span>{isLoggingOut ? 'Signing out...' : 'Redirecting to login...'}</span>
      </div>
    );
  }

  // User is authenticated but doesn't have the required role
  if (!hasRequiredRole) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
